import classNames from 'classnames';

import { TickMark } from '@/components/SvgComponents/TickMark';
import { Store } from '@/components/SvgComponents/Store';

import styles from './index.module.scss';

export const SingleBranch = ({ branch, adress, onClick, active }) => {
  return (
    <div
      onClick={onClick}
      className={classNames(styles.branch, { [styles.branch__active]: active })}
      itemScope
      itemType='https://schema.org/Organization'
    >
      <div className={styles.left}>
        <Store />
      </div>
      <div className={styles.right}>
        <div className={styles.texts}>
          <p>{branch}</p>
          <p>{adress}</p>
        </div>
        {active && <TickMark />}
      </div>
    </div>
  );
};
